import { pluralizeRu } from "./pluralizeRu";

const DAY_MS = 24 * 60 * 60 * 1000;

const utcDay = (date: Date) =>
  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

/** Дней просрочки по дням UTC (биллинг живёт днями UTC); ноль, если срок сегодня или позже. */
export function overdueDays(
  expiredAt: string | Date,
  now: Date = new Date()
): number {
  const due = typeof expiredAt === "string" ? new Date(expiredAt) : expiredAt;
  if (Number.isNaN(due.getTime())) return 0;
  return Math.max(0, Math.round((utcDay(now) - utcDay(due)) / DAY_MS));
}

/**
 * Подпись просрочки для чипа: «просрочка 6 дней». Одна на админку
 * (карточка платежа, дашборд); без просрочки пустая строка.
 */
export function overdueLabel(days: number): string {
  if (days <= 0) return "";
  return `просрочка ${days} ${pluralizeRu(days, ["день", "дня", "дней"])}`;
}
